import { AutomationObjectsSelector } from "../../automationObjectsSelector";
import { IAutomationObject } from "../../types";
import CardWithAlarm from "./CardWithAlarm";

export function AutomationObjectCard(props: { item: IAutomationObject, additionalProps?: any, small?: boolean }) {
    const item = props.item;
    const mystate = { ...item, ...props.additionalProps};
    return (
        <CardWithAlarm small={props.small} objectId={item.id} resourceGroupId={item.resourceGroupId} >
            <AutomationObjectsSelector  tag={item.schema} state={mystate}></AutomationObjectsSelector>
        </CardWithAlarm>)
}